module.exports = __webpack_public_path__ + "img/next.29de9914.png";